import { Message } from "../entities/app-entities/Message";
import { EventBus } from "./event-bus";
export default {
  manageError(context, error) {
    var message = null;
    switch (error.status) {
      case 0:
        message = new Message(
          context.$t("error.server_unavailable"),
          6000,
          "error"
        );
        break;
      case 400:
        context.formErrors = {};
        error.body.forEach((error) => {
          context.formErrors[error.key] = context.$t(
            "error.bad_request." + error.error
          );
        });
        break;
      case 403:
        context.formErrors = {
          login: context.$t("error.forbidden"),
        };
        break;
      case 401:
        context.auth.logout(context);
        break;
      case 409:
        message = new Message(
          context.$t("error.conflict." + error.body.error),
          6000,
          "error"
        );
        break;
      case 500:
        message = new Message(context.$t("error.server_error"), 6000, "error");
        break;
      case 502:
        context.auth.logout(context);
        break;
    }
    if (message) {
      EventBus.$emit("showMessage", message);
    }
  },
};
